<template>
  <tr>
    <td>
      <a
        class="icon"
        href="#"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="19"
          height="18"
          viewBox="0 0 19 18"
        >
          <path
            fill="#064BC3"
            fill-rule="evenodd"
            d="M4.186 11.56l-.923 5.308a.963.963 0 0 0 .215.793.964.964 0 0 0 1.167.231l4.855-2.52 4.854 2.52a.955.955 0 0 0 1.168-.232.963.963 0 0 0 .214-.792l-.922-5.309 3.889-3.742a.963.963 0 0 0 .248-1.001.953.953 0 0 0-.775-.652l-5.391-.773L10.356.53a.955.955 0 0 0-1.712 0L6.215 5.39l-5.391.773a.953.953 0 0 0-.775.652.963.963 0 0 0 .248 1l3.889 3.744z"
          />
        </svg>
      </a>
    </td>
    <td>
      <a
        :href="downloadUrl"
        target="_blank"
        rel="noopener noreferrer"
        v-html="title"
      />
    </td>
    <td v-html="modified" />
    <td>
      <a
        class="icon"
        :href="downloadUrl"
        target="_blank"
        rel="noopener noreferrer"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="25"
          height="24"
          viewBox="0 0 25 24"
        ><g
          fill="#231F20"
          fill-rule="evenodd"
          stroke="#231F20"
          stroke-width=".5"
        ><path d="M7.5 7.5A.5.5 0 0 0 7 7H1.5a.5.5 0 0 0-.5.5v15a.5.5 0 0 0 .5.5h22a.5.5 0 0 0 .5-.5v-15a.5.5 0 0 0-.5-.5H18a.5.5 0 0 0 0 1h5v14H2V8h5a.5.5 0 0 0 .5-.5z" /><path d="M12.5 1a.5.5 0 0 0-.5.5v13.793l-3.146-3.146a.5.5 0 0 0-.708.707l3.999 3.999a.496.496 0 0 0 .708 0l3.999-3.999a.5.5 0 0 0-.707-.707L13 15.293V1.5a.5.5 0 0 0-.5-.5z" /></g></svg>
      </a>
    </td>
  </tr>
</template>

<script type="text/babel">
export default {
  name: 'DocumentHistoryRow',
  props: {
    document: {
      type: Object,
      required: true,
    },
  },
  computed: {
    downloadUrl() {
      return this.$urlGenerator.active(`documents/${this.document.uuid}/download`)
    },
    title() {
      return this.document.attributes.title
    },
    modified() {
      return this.$date.toMomentDateFormat(this.document.attributes.created_at)
    },
    groups() {
      return '-'
    },
    hasHistory() {
      return this.document.attributes.has_history
    },
  },
}
</script>
